module.exports = __webpack_public_path__ + "static/media/DC_F_Timeless_Sforza_LTGrey.8fb07dbd.png";